import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/fermentations/$group_id/results")({
  component: ResultsLayout,
});

function ResultsLayout() {
  return <Outlet />;
}

